import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import CampingClub from "@/pages/CampingClub";

export const Route = createFileRoute("/camping-club")({
  head: () => pageHead({
    title: 'Camping Club',
    description: 'Join the Rex & Sons RVs camping club — exclusive campground discounts, member events and perks for RV owners in southeastern NC.',
    path: '/camping-club',
  }),
  component: CampingClub,
});
